<div *ngIf="checkliste">
  <ng-container *ngIf="titelAnzeigen">
    <!-- Wenn kein Titel vorhanden ist, wird der Name der Checkliste angezeigt -->
    <h1 *ngIf="!checkliste.titel">{{ 'Checkliste' | translate }}: {{ checkliste.name }}</h1>

    <h1 *ngIf="checkliste.titel">{{ checkliste.titel }}</h1>
  </ng-container>
  
  <div *ngFor="let p of eintraege; let index = index;" class="disable-hover">
    <!-- Ok / Nicht ok -->
    <ng-container *ngIf="p.eintrag.antworten == '1'">
      <p>{{ p.eintrag.text }}</p>

      <ion-segment class="typ-1" (ionChange)="antwortChanged($event, p)" [disabled]="istReadonly" [(ngModel)]="p.antwort">
        <ion-segment-button value="ok" class="value-ok" appClick (clicked)="onAntwortClicked(p, 'ok')">
          <ion-label>{{ 'OK' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="nok" class="value-nok" appClick (clicked)="onAntwortClicked(p, 'nok')">
          <ion-label>{{ 'Nicht OK' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ng-container>

    <!-- Sehr gut - Mangelhaft (1-5) -->
    <ng-container *ngIf="p.eintrag.antworten == '2'">
      <p>{{ p.eintrag.text }}</p>

      <ion-segment class="typ-2" (ionChange)="antwortChanged($event, p)" [disabled]="istReadonly" [(ngModel)]="p.antwort">
        <ion-segment-button value="1" class="value-1" appClick (clicked)="onAntwortClicked(p, '1')">
          <ion-label>1</ion-label>
        </ion-segment-button>
        <ion-segment-button value="2" class="value-2" appClick (clicked)="onAntwortClicked(p, '2')">
          <ion-label>2</ion-label>
        </ion-segment-button>
        <ion-segment-button value="3" class="value-3" appClick (clicked)="onAntwortClicked(p, '3')">
          <ion-label>3</ion-label>
        </ion-segment-button>
        <ion-segment-button value="4" class="value-4" appClick (clicked)="onAntwortClicked(p, '4')">
          <ion-label>4</ion-label>
        </ion-segment-button>
        <ion-segment-button value="5" class="value-5" appClick (clicked)="onAntwortClicked(p, '5')">
          <ion-label>5</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ng-container>

    <!-- Ja / Nein -->
    <ion-item class="ion-no-padding normal-height" *ngIf="p.eintrag.antworten == '3'">
      <ion-label>{{ p.eintrag.text }}</ion-label>

      <ion-button slot="end" size="default" [color]="p.jaButtonColor | async" appClick (clicked)="onAntwortClicked(p, 'ja')" class="toggle-button">Ja</ion-button>
      <ion-button slot="end" size="default" [color]="p.neinButtonColor | async" appClick (clicked)="onAntwortClicked(p, 'nein')" class="toggle-button">Nein</ion-button>
    </ion-item>

    <!-- 
    <p *ngIf="p.eintrag.antworten == '3'">{{ p.eintrag.text }}</p>
    <ion-segment *ngIf="p.eintrag.antworten == '3'" class="typ-3" (ionChange)="antwortChanged($event, p)" [disabled]="istReadonly">
      <ion-segment-button value="ja" class="value-ja" [checked]="p.antwort == 'ja'" appClick (clicked)="onAntwortClicked(p, 'ja')">
        <ion-label>{{ 'Ja' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="nein" class="value-nein" [checked]="p.antwort == 'nein'" appClick (clicked)="onAntwortClicked(p, 'nein')">
        <ion-label>{{ 'Nein' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment> -->

    <!-- Benutzerdefiniert-->
    <ng-container *ngIf="p.eintrag.antworten == '4'">

      <!-- Radio-Buttons -->
      <ng-container *ngIf="p.config?.darstellung === 'radio'">
        <p class="mb-5 eintrag-title">{{ p.eintrag.text }}</p>


        <!-- <ng-container *ngFor="let a of p.moeglicheAntworten">
          <ion-radio [value]="a.value" labelPlacement="end">{{ a.value }}</ion-radio><br />
        </ng-container> -->

        <ion-radio-group [value]="p.antwort" (ionChange)="antwortChanged($event, p)">
          <ion-item lines="none" *ngFor="let a of p.moeglicheAntworten">
            <ion-radio slot="start" [value]="a.value" labelPlacement="end" [disabled]="istReadonly">{{ a.value }}</ion-radio>
          </ion-item>
        </ion-radio-group>
      </ng-container>

      <!-- Standard-Darstellung -->
      <ng-container *ngIf="p.config?.darstellung !== 'radio'">
        <p class="eintrag-title">{{ p.eintrag.text }}</p>
        <ion-segment class="typ-4" (ionChange)="antwortChanged($event, p)" [disabled]="istReadonly" [(ngModel)]="p.antwort">
          <ion-segment-button *ngFor="let a of p.moeglicheAntworten" [value]="a.value" class="value-benutzerdefiniert-{{ a.cssTyp }} segment-{{p.moeglicheAntworten.length}}" appClick (clicked)="onAntwortClicked(p, a.value)">
            <span class="foo">{{ a.value }}</span>
          </ion-segment-button>
        </ion-segment>
      </ng-container>

    </ng-container>

    <!-- Toggle -->
    <ion-item class="ion-no-padding normal-height" *ngIf="p.eintrag.antworten == '5'">
      <!--  lines="none" -->
      <ion-label>{{ p.eintrag.text }}</ion-label>
      <ion-toggle mode="ios" class="typ-5" [checked]="p.antwort === 'ja'" (ionChange)="toggleAntwortChanged($event, p)" [disabled]="istReadonly"></ion-toggle>
    </ion-item>

    <!-- Freitext -->
    <div class="mt-25 mb-25" *ngIf="p.eintrag.antworten == '6'">
      <app-input-textarea
                          [titel]="p.eintrag.text"
                          [(ngModel)]="p.antwort"
                          cssClass="checklist"
                          placeholder=""
                          [disabled]="istReadonly"
                          (valueChanged)="afterAntwortChanged(p)"
                          [required]="p.config?.erforderlich"></app-input-textarea>
    </div>

    <!-- Fotos -->
    <div class="mt-25 mb-25" *ngIf="p.eintrag.antworten == '7'">
      <p class="eintrag-title">{{ p.eintrag.text }}</p>

      <app-fotos [bilder]="p.bilder"
                 [readOnly]="istReadonly"
                 filenamePrefix="Checkliste-"
                 (neuesBild)="onNeuesBild(p, $event)"
                 (bildGeloescht)="onBildGeloescht(p, $event)"></app-fotos>
    </div>

    <!-- Einzeiliger Text -->
    <div class="mt-15 mb-15" *ngIf="p.eintrag.antworten == '8'">
      <app-input-text
                      [titel]="p.eintrag.text"
                      [(ngModel)]="p.antwort"
                      [uppercase]="false"
                      [required]="p.config?.erforderlich"
                      [readOnly]="istReadonly"
                      (valueChanged)="afterAntwortChanged(p)"
                      labelPosition="stacked">
      </app-input-text>
    </div>

    <!-- Zahl -->
    <div class="mt-15 mb-15" *ngIf="p.eintrag.antworten == '9'">
      <app-input-number [titel]="p.eintrag.text"
                        [(ngModel)]="p.antwort"
                        placeholder=""
                        lines="none"
                        type="decimal"
                        einheit=""
                        cssClass="style2"
                        [step]="0.5"
                        [clearInput]="!istReadonly"
                        [readOnly]="istReadonly"
                        [noEmptySpace]="istReadonly"
                        [plusMinusButtons]="false"
                        [required]="p.config?.erforderlich"
                        (valueChanged)="afterAntwortChanged(p)"
                        labelPosition="stacked"></app-input-number>
    </div>

    <!-- Gruppen Überschrift -->
    <div class="mt-15 mb-15" *ngIf="p.eintrag.antworten == '10'">
      <h1 class="gruppen-ueberschrift" [class.istErsterEintrag]="index === 0">{{ p.eintrag.text }}</h1>
    </div>

    <div *ngIf="p.config?.freitext && p.config?.freitext === p.antwort">
      <app-input-textarea
                          titel=""
                          [(ngModel)]="p.freitext"
                          cssClass="checklist"
                          placeholder=""
                          [disabled]="istReadonly"
                          (valueChanged)="afterAntwortChanged(p)"
                          [required]="true"></app-input-textarea>
    </div>

    <!-- <ion-segment *ngIf="p.eintrag.antworten == '5'" class="typ-3" (ionChange)="antwortChanged($event, p)" [disabled]="istReadonly">
      <ion-segment-button value="ja" class="value-ja" [checked]="p.antwort == 'ja'" appClick (clicked)="onAntwortClicked(p, 'ja')">
        <ion-label>{{ 'Ja' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="nein" class="value-nein" [checked]="p.antwort == 'nein'" appClick (clicked)="onAntwortClicked(p, 'nein')">
        <ion-label>{{ 'Nein' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment> -->
  </div>
</div>